// export const environment = {
//   production: false,
//   firebaseConfig: {
//     apiKey: 'AIzaSyD4whYZk6F97tIkSQVdvezod2XVISah6GY',
//     authDomain: 'taxi-mallorca-develop.firebaseapp.com',
//     projectId: 'taxi-mallorca-develop',
//     storageBucket: 'taxi-mallorca-develop.appspot.com',
//     messagingSenderId: '214034210798',
//     appId: '1:214034210798:web:717ecede6d1adba0f138ff',
//     measurementId: 'G-MRFRSEQWTQ'
//   },
//   language: {
//     defaultLang: 'es',
//     available: ['es']
//   },
//   apiMainUrl: 'https://main-develop.mallorcab.com',
//   apiCalculatorUrl: 'https://calculator-develop.mallorcab.com',
//   socketMainUrl: 'wss://main-develop.mallorcab.com/',
//   socketCalculatorUrl: 'wss://calculator-develop.mallorcab.com/',
//   configurationId: 1,
//   geoapify: '38c1835e313046e39800f6989de2c943'
// };
export const environment = {
  production: false,
  /* 
  firebaseConfig: {
    apiKey: 'AIzaSyA8slxGupKW_cfCOTjPYnhnsybpmCE1_pY',
    authDomain: 'mallorcab-taxi.firebaseapp.com',
    projectId: 'mallorcab-taxi',
    storageBucket: 'mallorcab-taxi.appspot.com',
    messagingSenderId: '1008709237636',
    appId: '1:1008709237636:web:273d49b997065c4a8e7bd1',
    measurementId: 'G-652NT2QRX1'
  }, */
     firebaseConfig: {
     apiKey: 'AIzaSyD4whYZk6F97tIkSQVdvezod2XVISah6GY',
     authDomain: 'taxi-mallorca-develop.firebaseapp.com',
     projectId: 'taxi-mallorca-develop',
     storageBucket: 'taxi-mallorca-develop.appspot.com',
     messagingSenderId: '214034210798',
     appId: '1:214034210798:web:717ecede6d1adba0f138ff',
     measurementId: 'G-MRFRSEQWTQ'
   },
  language: {
    defaultLang: 'es',
    available: ['es']
  },
  // apiMainUrl: 'https://main.mallorcab.com',
  // apiCalculatorUrl: 'https://calculator.mallorcab.com',
  // socketMainUrl: 'wss://main.mallorcab.com/',
  // socketCalculatorUrl: 'wss://calculator.mallorcab.com/',
  apiMainUrl: 'https://main-develop.mallorcab.com',
  apiCalculatorUrl: 'https://calculator-develop.mallorcab.com',
  socketMainUrl: 'wss://main-develop.mallorcab.com/',
  socketCalculatorUrl: 'wss://calculator-develop.mallorcab.com/',
  configurationId: 1,
  geoapify: '38c1835e313046e39800f6989de2c943'
};
